import { makeObservable } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import type { FirebaseRepository } from './FirebaseRepository'
import {
  empty,
  type FirestoreSettingsDynamicIntroVideoDefaults,
} from '../firestore/SettingsDynamicIntroVideoDefaults'

export class SettingsDynamicIntroVideoDefaults extends ObservableModelWithDecorators<FirestoreSettingsDynamicIntroVideoDefaults> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreSettingsDynamicIntroVideoDefaults>
  ) {
    super(repository, doc)

    makeObservable(this)
  }
}
